;
(function ($) {
	"use strict";
	window.Demand = function (options) {
		this._init(options);
	};

	$.extend(Demand.prototype, {
		$options: {
		},

		//=====================================================================
		// COMMENTS
		//=====================================================================

		/**
		 * 
		 */
		createComment: function ($button) {
			$button.attr('disabled', 'disabled');
			
			var template = $('#comment-template').html();
			$('#comments').prepend($(template));
		},

		/**
		 * @param $button
		 */
		cancelComment: function ($button) {
			var $row = $button.closest('div.row');
			$row.remove();
			
			$('button.js-create-comment').removeAttr('disabled');
		},

		/**
		 * @param $li
		 */
		tabChangedRecipientType: function ($li) {
			var value = $li.data('value'),
				$input = $($li.data('inputSelector'));
			$input.val(value).trigger('change');
		},
		
		//=====================================================================

		/**
		 * HANDLE BUTTONS
		 */
		handleButtons: function() {
			var app = this,
				$document = $(document);

			$document.on('click', ".js-create-comment", function () {
				app.createComment($(this));
			});
			$document.on('click', ".cancel-comment", function () {
				app.cancelComment($(this));
			});

			$document.on('click', '#recipients-section li', function () {
				app.tabChangedRecipientType($(this));
			});
		},

		_init: function () {
			this.handleButtons();
		},
	});

})(jQuery);

